// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"pause-circle"},"nodeName":"g","children":[{"attributes":{"fill":"currentColor","d":"M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 7H16V17H13V7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8 7H11V17H8V7Z"},"nodeName":"path","children":[]}]}]};

@tag('t-icon-pause-circle')
export default class PauseCircleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'pause-circle',
    }
  }
}
